import { useGT } from 'gt-react';
import { cn } from '@/lib/utils';
import type { BuyingGroupBy } from '../utils/buyingOrdersUrl';

interface BuyingGroupByToggleProps {
  value: BuyingGroupBy;
  onChange: (next: BuyingGroupBy) => void;
}

/** Orders-header switch between a row per cart and a row per vendor. */
export function BuyingGroupByToggle({
  value,
  onChange,
}: BuyingGroupByToggleProps) {
  const gt = useGT();
  const options: { id: BuyingGroupBy; label: string }[] = [
    {
      id: 'vendor_location',
      label: gt('Vendor × location', {
        context: 'buying orders group-by option, a row per cart',
      }),
    },
    {
      id: 'vendor',
      label: gt('Vendor', {
        context: 'buying orders group-by option, a row per vendor',
      }),
    },
  ];
  return (
    <div
      role="group"
      aria-label={gt('Group by', { context: 'buying orders group-by label' })}
      className="flex h-5 shrink-0 items-center overflow-hidden rounded-sm border border-border"
    >
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          aria-pressed={value === option.id}
          onClick={() => value !== option.id && onChange(option.id)}
          className={cn(
            'h-full whitespace-nowrap px-1.5 text-[11px]',
            value === option.id
              ? 'bg-muted font-medium text-foreground'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
